export default __webpack_public_path__ + "images/Coronal_View_of_Upper_Lip_Nose_Nostrils.0404e5f63ea5b5d101d7b4c9db123189.png";